import React from 'react';
import { Link } from 'react-router-dom';
import './sectionTwo.css';

function SectionTwo() {
    return (
        <div className='sectionTwo__main'>
            <div className="sectionTwo__top">
                <div data-aos="fade-down"data-aos-duration="500" className="head__two workout2" >
                Explore Our Classes by category
                </div>
                <div data-aos="fade-down" data-aos-duration="1000"  className="paragraph workout">Upskill your child based on the categories below</div>
                <div data-aos="fade-down" data-aos-duration="1500" className="tagline workout"> <Link to='course'> See all category here </Link> </div>
            </div>
           
        </div>
    )
}

export default SectionTwo
